import styled from "styled-components";


export const SidebarContainer = styled.div`
  width: 30%;
  position: relative;

  @media (max-width: 960px) {
    width: 100%;
  }
`;

export const SidebarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: #008394;
`;

export const SidebarToggle = styled.button`
  display: none;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  padding: 10px;
  background: #fff;
  color: #008394;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 300;
  margin: 10px;

  span {
    flex: 1;
    text-align: left;
  }

  @media (max-width: 960px) {
    display: flex;
  }
`;

export const Sidebar = styled.div`
  width: 95%;
  background: #f5f5f5;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: max-height 0.3s ease, opacity 0.3s ease;

  @media (max-width: 960px) {
    max-height: ${(props) => (props.isExpanded ? "1000px" : "0")};
    opacity: ${(props) => (props.isExpanded ? "1" : "0")};
    overflow: hidden;
    padding: ${(props) => (props.isExpanded ? "10px" : "0")};
    margin: 10px;
  }
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
`;

export const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    font-size: 18px;
    margin: 0;
  }
`;

export const FilterGroupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h4 {
    font-size: 16px;
    margin: 0;
  }
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  color: #008394;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h4 {
    font-size: 16px;
    margin: 0;
    margin-bottom: 8px;
  }
`;

export const FilterOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const FilterOption = styled.div`
  background: ${(props) => (props.isSelected ? "#008394" : "#e0e0e0")};
  color: ${(props) => (props.isSelected ? "white" : "#333")};
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => (props.isSelected ? "#006d7a" : "#d0d0d0")};
  }
`;


export const BackButtonContainer = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  padding: 10px 12px;
  border-radius: 6px;
  font-weight: 500;
  color: #555;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #e9e9e9;
    color: #8A2BE2;
    transform: translateX(-2px);
  }
  
  &:active {
    background: #ddd;
  }
  
  &:focus {
    outline: 2px solid #0066cc30;
  }
`;

export const ButtonText = styled.span`
  font-size: 14px;
`;